/* Maharaja Shop - behaviour for the collection page sections (mm-shop-*).
   Filters, chips, sort and "Show more" update the products in place with the Section Rendering API
   (the URL changes too, so Back and shared links work); without JavaScript the same form, links and
   pagination load plain pages. Quick view reads /products/<handle>.js; Add to cart uses /cart/add.js. */
(function () {
  'use strict';
  // every section includes this file; run it once
  if (window.__mmShop) return;
  window.__mmShop = true;

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const html = document.documentElement;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const store = {
    // a stored value of the wrong shape (e.g. {} where a list is expected) falls back to the default
    get(k, d) { try { const v = localStorage.getItem(k); if (v == null) return d; const p = JSON.parse(v); return Array.isArray(d) && !Array.isArray(p) ? d : p; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
  };
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const SVG = d => `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">${d}</svg>`;
  const ICON = {
    close: SVG('<path d="M6 6l12 12M18 6 6 18"/>'),
    bag: SVG('<path d="M5 8h14l-1 12H6Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>'),
    wa: SVG('<path d="M4.5 19.5 5.6 16A8 8 0 1 1 8.4 18.6Z"/><path d="M9.2 8.6c.2-.5.6-.5.9-.5h.5c.2 0 .4.1.5.4l.7 1.6c.1.2 0 .5-.1.6l-.5.6c-.1.2-.1.4 0 .5.6 1 1.4 1.8 2.4 2.3.2.1.4.1.5-.1l.6-.6c.2-.2.4-.2.6-.1l1.6.7c.3.1.4.3.4.5v.5c0 .4-.2.8-.6 1-1.4.7-3.6.1-5.4-1.7-1.8-1.8-2.4-4-1.9-5.7Z"/>')
  };
  // the theme's own icons (snippets/mm-theme-icons-template.liquid) replace these line drawings when present
  const themeIcons = document.getElementById('mm-theme-icons');
  if (themeIcons) for (const k of Object.keys(ICON)) {
    const el = themeIcons.content.querySelector(`[data-icon="${k}"]`);
    if (el) ICON[k] = el.innerHTML.trim();
  }

  /* ---------------- theme header: sticky sidebar and toolbar sit under it ---------------- */
  let hdrEls = [];
  const findHeaders = () => {
    hdrEls = $$('header, [id*="header" i], [class*="header" i], sticky-header').filter(el => {
      if (el.closest('[data-mm-shop]')) return false;
      const cs = getComputedStyle(el);
      return (cs.position === 'fixed' || cs.position === 'sticky') && cs.display !== 'none' && el.offsetHeight > 0 && el.offsetHeight < 240;
    });
  };
  const headerOffset = () => {
    let h = 0;
    hdrEls.forEach(el => { const r = el.getBoundingClientRect(); if (r.top <= 1 && r.height < 240 && r.bottom > h) h = r.bottom; });
    return Math.max(0, Math.round(h));
  };
  let hTick = false;
  // the Maharaja header sets the offset itself, to where it is going (0 / its height) as its slide starts,
  // so the sidebar slides with it; measuring it mid-slide here overwrote that and left a gap above the sidebar
  const ownHeader = () => !!document.querySelector('#header-group .mm-hdr');
  const setOffset = () => { if (!ownHeader()) html.style.setProperty('--mm-header-offset', headerOffset() + 'px'); hTick = false; };
  addEventListener('scroll', () => { if (!hTick) { hTick = true; requestAnimationFrame(setOffset); } }, { passive: true });
  addEventListener('resize', () => { findHeaders(); setOffset(); });

  /* ---------------- toasts ---------------- */
  let toastBox = null;
  const toast = (msg, link) => {
    if (!toastBox) { toastBox = document.createElement('div'); toastBox.className = 'mm-shop-toasts'; toastBox.setAttribute('aria-live', 'polite'); document.body.appendChild(toastBox); }
    const t = document.createElement('div');
    t.className = 'mm-shop-toast'; t.textContent = msg;
    if (link) { const a = document.createElement('a'); a.href = link.href; a.textContent = link.label; t.appendChild(a); }
    toastBox.appendChild(t); setTimeout(() => t.remove(), 3300);
  };

  /* ---------------- money, in the shop's own format ---------------- */
  const money = (cents, fmt) => {
    const n = (cents || 0) / 100;
    const two = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const none = Math.round(n).toLocaleString('en-IN');
    return (fmt || 'Rs. {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) =>
      k.indexOf('no_decimals') > -1 ? none : k === 'amount_with_comma_separator' ? two.replace(/,/g, '.').replace(/\.(\d\d)$/, ',$1') : two);
  };

  /* ---------------- scrim: shared by the filter drawer and quick view ---------------- */
  let scrim = null, openPanel = null, lastFocus = null;
  const getScrim = () => {
    if (!scrim) { scrim = document.createElement('div'); scrim.className = 'mm-shop-scrim'; document.body.appendChild(scrim); scrim.addEventListener('click', () => closePanel()); }
    return scrim;
  };
  const openPanelEl = (el, onClose) => {
    if (openPanel) closePanel(true);
    lastFocus = document.activeElement;
    openPanel = { el, onClose };
    el.inert = false;
    el.setAttribute('aria-modal', 'true');
    el.classList.add('is-open');
    getScrim().classList.add('is-on');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { const f = $('button, a[href], input', el); f && f.focus(); }, 60);
  };
  const closePanel = keep => {
    if (!openPanel) return;
    const { el, onClose } = openPanel;
    el.classList.remove('is-open'); openPanel = null;
    el.removeAttribute('aria-modal');
    if (el === qv) el.inert = true;
    if (onClose) onClose();
    if (!keep) { getScrim().classList.remove('is-on'); document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  };
  document.addEventListener('keydown', e => {
    if (!openPanel) return;
    if (e.key === 'Escape') closePanel();
    if (e.key === 'Tab' && openPanel) {
      const items = $$('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]', openPanel.el).filter(item => item.offsetParent !== null);
      const first = items[0], last = items[items.length - 1];
      if (first && e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (last && !e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- add to cart (cards and quick view) ----------------
     Same path as the theme's own product form (Ella / Dawn): the theme's <cart-drawer> asks for its
     sections, re-renders with them (header count included) and opens. Without a drawer the header
     cart bubble is updated here and a toast links to the cart. */
  const refreshBubble = () => fetch(root + 'cart.js').then(r => r.json()).then(cart => {
    const n = cart.item_count;
    $$('.cart-bubble').forEach(b => b.classList.toggle('visually-hidden', !n));
    $$('.cart-bubble__text-count').forEach(c => c.classList.toggle('hidden', !n));
    $$('.cart-bubble__text-count span[aria-hidden], .cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(el => { el.textContent = n < 100 ? n : '99+'; });
  }).catch(() => { });
  const addToCart = (body, btn) => {
    if (btn && btn.disabled) return Promise.resolve(false);
    if (btn) btn.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const viaDrawer = drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
    if (viaDrawer) {
      body.append('sections', drawer.getSectionsToRender().map(s => s.id));
      body.append('sections_url', location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
    }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body })
      .then(r => r.json().then(d => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok || d.status) throw new Error(d.description || d.message || 'Could not add this saree');
        // the theme's own listeners (cart page, free-shipping bar, ...)
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-shop', productVariantId: body.get('id'), cartData: d }); } catch (e) { }
        document.dispatchEvent(new CustomEvent('mm:cart:add', { bubbles: true, detail: d }));
        if (viaDrawer) {
          closePanel();                 // quick view out of the way, then the theme's cart drawer opens
          drawer.renderContents(d);
        } else {
          toast('Added to your cart', { href: root + 'cart', label: 'View cart' });
          refreshBubble();
        }
        return true;
      })
      .catch(err => { toast(err.message || 'Could not add this saree'); return false; })
      .finally(() => { if (btn) btn.disabled = false; });
  };

  /* ---------------- wishlist hearts: the theme's <wish-list> handles clicks; this paints saved
     hearts on cards that arrive later (filters, Show more), from localStorage "wishlistItem" ---------------- */
  const syncWishlist = scope => {
    let list = [];
    try { list = JSON.parse(localStorage.getItem('wishlistItem')) || []; } catch (e) { list = []; }
    $$('[data-wishlist-handle]', scope).forEach(b => {
      const on = list.indexOf(b.dataset.wishlistHandle) > -1;
      b.classList.toggle('wishlist-added', on);
      b.setAttribute('aria-pressed', on);
    });
  };
  document.addEventListener('add:wishlist-item', () => $$('[data-mm-shop]').forEach(syncWishlist));
  document.addEventListener('remove:wishlist-item', () => $$('[data-mm-shop]').forEach(syncWishlist));
  document.addEventListener('submit', e => {
    const form = e.target.closest && e.target.closest('[data-mm-shop] form[data-mm-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    addToCart(new FormData(form), $('button', form));
  });

  /* ---------------- recently viewed: sarees opened from the shop page, in this browser ---------------- */
  const RECENT = 'mm-shop-recent';
  const remember = pc => {
    if (!pc || !pc.dataset.handle) return;
    const img = $('.pc-media img', pc), name = $('.pc-name a', pc), price = $('.price > span', pc), fab = $('.pc-fab', pc);
    const item = {
      h: pc.dataset.handle, t: name ? name.textContent.trim() : '', u: name ? name.getAttribute('href') : '',
      i: img ? (img.currentSrc || img.src) : '', p: price ? price.textContent.trim() : '', f: fab ? fab.textContent.trim() : ''
    };
    const list = (store.get(RECENT, []) || []).filter(x => x && x.h !== item.h);
    list.unshift(item); store.set(RECENT, list.slice(0, 12)); // same length as mm-product.js
  };
  const renderRecent = rootEl => {
    const box = $('[data-shp-recent]', rootEl), row = $('[data-shp-recent-row]', rootEl);
    if (!box || !row) return;
    const list = (store.get(RECENT, []) || []).filter(x => x && x.h).slice(0, +box.dataset.limit || 4);
    box.hidden = !list.length;
    if (!list.length) return;
    // first the saved copy (instant), then each saree's real card (badge, heart, quick view, today's price)
    // from the product page's Recently viewed section rendered at its URL
    row.innerHTML = list.map(x => `<article class="pc" data-handle="${esc(x.h)}">
      <div class="pc-top"><a class="pc-media" href="${esc(x.u)}" tabindex="-1" aria-hidden="true">${x.i ? `<img src="${esc(x.i)}" alt="" loading="lazy" width="600" height="800">` : ''}</a></div>
      <div class="pc-info">${x.f ? `<span class="pc-fab">${esc(x.f)}</span>` : ''}<h3 class="pc-name"><a href="${esc(x.u)}">${esc(x.t)}</a></h3><p class="price"><span>${esc(x.p)}</span></p></div>
    </article>`).join('');
    Promise.all(list.map(x => fetch(`${root}products/${encodeURIComponent(x.h)}?section_id=mm-product-recent`)
      .then(r => r.ok ? r.text() : null)
      .then(t => { if (!t) return null; const tpl = new DOMParser().parseFromString(t, 'text/html').querySelector('template[data-pdp-card]'); return tpl ? tpl.content.firstElementChild : null; })
      .catch(() => null)))
      .then(cards => {
        if (!row.isConnected) return;
        const now = $$(':scope > .pc', row);
        cards.forEach((c, i) => { if (c && now[i]) now[i].replaceWith(document.importNode(c, true)); });
        syncWishlist(rootEl);
      });
  };

  /* ---------------- quick view drawer (one, on <body>) ---------------- */
  let qv = null;
  const getQv = () => {
    if (qv) return qv;
    qv = document.createElement('aside');
    qv.className = 'mm-shop-qv'; qv.setAttribute('aria-label', 'Quick view'); qv.setAttribute('role', 'dialog');
    qv.inert = true;
    qv.innerHTML = `<div class="mm-shop-qv-head"><h2>Quick view</h2><button class="mm-shop-qv-x" type="button" aria-label="Close quick view">${ICON.close}</button></div><div class="mm-shop-qv-body"></div>`;
    document.body.appendChild(qv);
    $('.mm-shop-qv-x', qv).addEventListener('click', () => closePanel());
    return qv;
  };
  const imgUrl = (src, w) => { if (!src) return ''; const u = src.startsWith('//') ? 'https:' + src : src; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
  let quickController = null;
  const openQuick = (handle, rootEl) => {
    if (quickController) quickController.abort();
    const controller = quickController = new AbortController();
    const el = getQv(), body = $('.mm-shop-qv-body', el);
    const fmt = rootEl.dataset.money, wa = rootEl.dataset.wa, waText = rootEl.dataset.waText || '';
    body.innerHTML = '<p class="mm-shop-qv-load">Loading…</p>';
    openPanelEl(el);
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(p => {
        if (controller.signal.aborted || !rootEl.isConnected) return;
        const imgs = (p.media && p.media.length ? p.media.filter(m => m.media_type === 'image').map(m => m.src) : p.images) || [];
        const variants = p.variants || [];
        const many = variants.length > 1;
        let v = variants.find(x => x.available) || variants[0];
        if (!v) throw new Error('No variants');
        const url = location.origin + (p.url || root + 'products/' + p.handle);
        body.innerHTML = `
          <div class="mm-shop-qv-media"><img src="${esc(imgUrl(imgs[0], 900))}" alt="${esc(p.title)}" data-qv-main></div>
          ${imgs.length > 1 ? `<div class="mm-shop-qv-thumbs">${imgs.slice(0, 8).map((s, i) => `<button type="button" aria-current="${i === 0}" aria-label="Photo ${i + 1}" data-src="${esc(imgUrl(s, 900))}"><img src="${esc(imgUrl(s, 160))}" alt=""></button>`).join('')}</div>` : ''}
          <div class="mm-shop-qv-info">
            ${p.type ? `<span class="mm-shop-qv-type">${esc(p.type)}</span>` : ''}
            <h3>${esc(p.title)}</h3>
            <p class="mm-shop-qv-price" data-qv-price></p>
            ${many ? `<label class="mm-shop-qv-variant">${esc((p.options && p.options[0] && p.options[0].name) || 'Option')}<select data-qv-variant>${variants.map(x => `<option value="${x.id}"${x.id === v.id ? ' selected' : ''}${x.available ? '' : ' disabled'}>${esc(x.title)}${x.available ? '' : ' (sold out)'}</option>`).join('')}</select></label>` : ''}
            <p class="mm-shop-qv-note">Handpicked for its weave and zari. Delivered across India in 3–7 days.</p>
            <div class="mm-shop-qv-acts">
              <button class="mm-shop-qv-btn mm-shop-qv-btn--add" type="button" data-qv-add>${ICON.bag}<span>Add to cart</span></button>
              ${wa ? `<a class="mm-shop-qv-btn mm-shop-qv-btn--wa" href="https://wa.me/${esc(wa)}?text=${encodeURIComponent((waText ? waText + ' ' : '') + p.title + ' ' + url)}" target="_blank" rel="noopener">${ICON.wa}Ask on WhatsApp</a>` : ''}
              <a class="mm-shop-qv-more" href="${esc(p.url || '#')}">View full details</a>
            </div>
          </div>`;
        const paint = () => {
          $('[data-qv-price]', body).innerHTML = money(v.price, fmt) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price, fmt)}</s>` : '');
          const add = $('[data-qv-add]', body);
          add.disabled = !v.available; $('span', add).textContent = v.available ? 'Add to cart' : 'Sold out';
          if (v.featured_image && v.featured_image.src) $('[data-qv-main]', body).src = imgUrl(v.featured_image.src, 900);
        };
        paint();
        const sel = $('[data-qv-variant]', body);
        if (sel) sel.addEventListener('change', () => { v = variants.find(x => String(x.id) === sel.value) || v; paint(); });
        $$('.mm-shop-qv-thumbs button', body).forEach(b => b.addEventListener('click', () => {
          $('[data-qv-main]', body).src = b.dataset.src;
          $$('.mm-shop-qv-thumbs button', body).forEach(x => x.setAttribute('aria-current', x === b));
        }));
        $('[data-qv-add]', body).addEventListener('click', e => {
          const fd = new FormData(); fd.append('id', v.id); fd.append('quantity', 1);
          addToCart(fd, e.currentTarget).then(added => { if (added && openPanel && openPanel.el === el && quickController === controller) closePanel(); });
        });
      })
      .catch(err => { if (err.name === 'AbortError' || controller.signal.aborted) return; body.innerHTML = '<p class="mm-shop-qv-load">This saree could not be loaded. <a href="' + root + 'products/' + encodeURIComponent(handle) + '">Open its page</a></p>'; });
  };

  // the same quick view for cards outside the shop sections (Home product grids): scope is any element
  // carrying data-money (and optionally data-wa / data-wa-text), usually the card's quick view button
  window.mmShopQuick = (handle, scope) => openQuick(handle, scope);

  /* fallback swatch colours, when a colour filter value has no swatch of its own */
  const SWATCH = [
    [['black', 'charcoal', 'onyx'], '#1f1a19'], [['maroon', 'wine', 'red', 'crimson', 'rust'], '#9b1b24'],
    [['pink', 'magenta', 'rose'], '#c2337a'], [['purple', 'violet', 'lavender'], '#5b2a86'],
    [['blue', 'navy', 'teal'], '#1f4e8c'], [['green', 'olive', 'lime'], '#2f6b3a'],
    [['yellow', 'mustard', 'orange', 'peach'], '#d99a1e'], [['gold', 'ivory', 'cream', 'beige', 'sand'], '#dcc490'],
    [['brown', 'coffee'], '#6b4426'], [['white'], '#f7f3ea'], [['grey', 'gray', 'silver'], '#9a9590']
  ];
  const swatchFor = name => { const n = (name || '').toLowerCase(); const hit = SWATCH.find(([w]) => w.some(x => n.indexOf(x) > -1)); return hit ? hit[1] : 'conic-gradient(#c2337a, #d99a1e, #2f6b3a, #1f4e8c, #c2337a)'; };

  /* =====================================================================
     One "Shop products" section
     ===================================================================== */
  function init(rootEl) {
    if (!rootEl || rootEl.dataset.mmShopReady) return;
    rootEl.dataset.mmShopReady = '1';
    rootEl.classList.add('mm-js');
    const ac = new AbortController();
    const opt = { signal: ac.signal };
    rootEl._mmDestroy = () => {
      ac.abort();
      if (openPanel && (rootEl.contains(openPanel.el) || openPanel.el === qv)) closePanel();
    };
    if (!rootEl.matches('[data-shp-main]')) {
      // other sections with Shop cards (Product page: You may also like, Recently viewed) get the quick
      // view too; the section carries data-money / data-wa / data-wa-text like the Shop products section
      rootEl.addEventListener('click', e => {
        const q = e.target.closest('[data-quick]');
        if (q) { e.preventDefault(); openQuick(q.dataset.quick, rootEl); }
      }, opt);
      return;
    }

    const sectionId = rootEl.dataset.section;
    const side = $('[data-shp-side]', rootEl), bar = $('[data-shp-bar]', rootEl);
    const grid = () => $('[data-shp-grid]', rootEl);
    const form = () => $('[data-shp-form]', rootEl);
    const openGroups = {};      // filter groups the visitor opened / closed: { param: true|false }
    const allColours = {};      // colour groups showing every colour

    /* ---------- cards per row: View as (desktop), 1 / 2 per row (phones) ---------- */
    const colsNow = () => { const g = grid(); return g ? getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length || 3 : 3; };
    const applyLayout = () => {
      const g = grid(); if (!g) return;
      const v = store.get('mm-shop-view', '') || g.dataset.viewDefault || '';
      if (v) g.dataset.view = v; else delete g.dataset.view;
      g.dataset.m = store.get('mm-shop-m', 2);
      const pressedView = g.dataset.view || String(colsNow());
      $$('.shp-viewas button', rootEl).forEach(b => b.setAttribute('aria-pressed', b.dataset.view === pressedView));
      $$('.shp-mview button', rootEl).forEach(b => b.setAttribute('aria-pressed', b.dataset.m === String(g.dataset.m)));
      placeBanner();
    };
    // the banner goes after row N of whatever the grid shows now (rows stay complete)
    const placeBanner = () => {
      const g = grid(); const b = g && $('[data-shp-banner]', g); if (!b) return;
      const rows = +rootEl.dataset.bannerRows || 3;
      const n = (g.dataset.view === 'list' ? 1 : colsNow()) * rows;
      const cards = $$(':scope > .pc', g).filter(c => c.style.display !== 'none');
      if (cards.length > n) { cards[n].before(b); b.hidden = false; } else b.hidden = true;
    };
    $$('.shp-viewas button', rootEl).forEach(b => b.addEventListener('click', () => { store.set('mm-shop-view', b.dataset.view); applyLayout(); }, opt));
    $$('.shp-mview button', rootEl).forEach(b => b.addEventListener('click', () => { store.set('mm-shop-m', +b.dataset.m); applyLayout(); }, opt));
    let lastCols = 0, rz = null;
    addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { const n = colsNow(); if (n !== lastCols) { lastCols = n; applyLayout(); } }, 150); }, { passive: true, signal: ac.signal });

    /* ---------- after every swap: colours, open groups, search, banner, counts ---------- */
    const afterSwap = () => {
      $$('.shp-sw i[data-cname]', rootEl).forEach(i => { if (!i.style.getPropertyValue('--c')) i.style.setProperty('--c', swatchFor(i.dataset.cname)); });
      $$('[data-shp-form] .shp-fg[data-g]', rootEl).forEach(d => {
        const g = d.dataset.g;
        if (g in openGroups) d.open = openGroups[g];
        if (allColours[g]) { d.classList.add('is-all'); const btn = $('[data-shp-morecol]', d); if (btn) btn.textContent = btn.dataset.less; }
      });
      applyLayout();
      filterByText();
      syncWishlist(rootEl);
      // the drawer's "Show N" mirrors the toolbar count
      const showBtn = $('[data-shp-swap="show"]', rootEl), fn = $('[data-shp-swap="fn"]', rootEl);
      if (showBtn) showBtn.setAttribute('data-shp-close', '');
      const fBtn = $('[data-shp-open]', rootEl); if (fBtn && fn) fBtn.setAttribute('aria-label', fn.hidden ? 'Filter' : `Filter, ${fn.textContent} on`);
      // Back/forward navigation swaps the form; keep the persistent sort control in sync.
      const sort = $('[data-shp-sort]', rootEl), value = $('[data-shp-sortval]', rootEl);
      if (sort && value) {
        const options = $$('li[data-v]', sort);
        options.forEach(option => option.setAttribute('aria-selected', option.dataset.v === value.value));
        const selected = options.find(option => option.dataset.v === value.value);
        const label = $('[data-shp-sortnow]', sort);
        if (selected && label) label.textContent = selected.textContent;
      }
    };

    /* ---------- loading results in place (Section Rendering API) ---------- */
    let ctrl = null;
    let shownUrl = location.pathname + location.search; // the filters / page on screen
    let pageReq = null; // the next page in flight, shared by Show more and the search box: { next, ctrl, promise }
    let resultsVersion = 0;
    ac.signal.addEventListener('abort', () => { if (ctrl) ctrl.abort(); if (pageReq) pageReq.ctrl.abort(); });
    const load = (url, { push = true, scroll = true } = {}) => {
      if (ac.signal.aborted) return Promise.resolve();
      const version = ++resultsVersion;
      if (pageReq) { pageReq.ctrl.abort(); pageReq = null; }
      const u = new URL(url, location.origin);
      u.searchParams.delete('section_id');
      const f = new URL(u); f.searchParams.set('section_id', sectionId);
      const results = $('[data-shp-results]', rootEl); if (results) results.classList.add('is-loading');
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      return fetch(f, { signal: ctrl.signal })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(text => {
          if (ac.signal.aborted || version !== resultsVersion) return;
          const doc = new DOMParser().parseFromString(text, 'text/html');
          $$('[data-shp-swap]', rootEl).forEach(el => {
            const nw = doc.querySelector(`[data-shp-swap="${el.dataset.shpSwap}"]`);
            if (nw) el.replaceWith(document.importNode(nw, true));
          });
          if (push) history.pushState({ mmShop: sectionId }, '', u.pathname + u.search);
          shownUrl = u.pathname + u.search;
          afterSwap();
          if (scroll) toResultsTop();
        })
        .catch(err => { if (err.name !== 'AbortError' && !ac.signal.aborted && version === resultsVersion) location.href = u.href; });
    };
    const toResultsTop = () => {
      if (side.classList.contains('is-open')) return;
      const top = rootEl.getBoundingClientRect().top + scrollY - headerOffset() - 8;
      if (scrollY > top + 4) scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    };
    const formUrl = () => {
      const fm = form(); const p = new URLSearchParams();
      new FormData(fm).forEach((v, k) => { if (k !== 'mm-band' && String(v).trim() !== '') p.append(k, v); });
      return location.pathname + (p.toString() ? '?' + p : '');
    };
    let changeT = null;
    rootEl.addEventListener('change', e => {
      const t = e.target, fm = t.closest('[data-shp-form]'); if (!fm) return;
      if (t.name === 'mm-band') {
        // a price band fills the range and applies it
        const [mn, mx] = $$('[data-shp-price]', fm);
        if (mn) mn.value = t.dataset.bandMin || ''; if (mx) mx.value = t.dataset.bandMax || '';
      } else if (t.matches('[data-shp-price]')) return; // the range applies with Go / Enter
      clearTimeout(changeT); changeT = setTimeout(() => load(formUrl(), { scroll: !side.classList.contains('is-open') }), 120);
    }, opt);
    rootEl.addEventListener('submit', e => {
      if (!e.target.matches('[data-shp-form]')) return;
      e.preventDefault(); load(formUrl());
    }, opt);
    rootEl.addEventListener('click', e => {
      const a = e.target.closest('a[data-shp-link]');
      if (a) { e.preventDefault(); load(a.href); return; }
      const more = e.target.closest('[data-shp-morecol]');
      if (more) {
        const g = more.closest('.shp-fg'); const on = !g.classList.contains('is-all');
        g.classList.toggle('is-all', on); allColours[g.dataset.g] = on; more.textContent = on ? more.dataset.less : more.dataset.more;
        return;
      }
      const pc = e.target.closest('.pc');
      if (pc && e.target.closest('a, [data-quick]')) remember(pc);
      const q = e.target.closest('[data-quick]');
      if (q) { e.preventDefault(); openQuick(q.dataset.quick, rootEl); }
    }, opt);
    rootEl.addEventListener('toggle', e => { const d = e.target; if (d.matches && d.matches('.shp-fg[data-g]')) openGroups[d.dataset.g] = d.open; }, { capture: true, signal: ac.signal });
    // Back / Forward: reload only when the filters or page changed, not for #hash jumps
    addEventListener('popstate', () => {
      const now = location.pathname + location.search;
      if (now === shownUrl) return;
      load(location.href, { push: false, scroll: false });
    }, opt);

    /* ---------- the next page appended in place: one request per page, whoever asks first ---------- */
    // resolves true when a page was added, false when there was nothing to add or the results changed meanwhile
    const appendNext = (moreBox = $('[data-shp-more]', rootEl)) => {
      const next = moreBox && moreBox.dataset.next;
      if (!next || moreBox.hidden) return Promise.resolve(false);
      if (pageReq && pageReq.next === next) return pageReq.promise;
      if (pageReq) pageReq.ctrl.abort();
      const btn = $('[data-shp-morebtn]', moreBox);
      if (btn) { btn.textContent = 'Loading…'; btn.setAttribute('aria-disabled', 'true'); }
      const f = new URL(next, location.origin); f.searchParams.set('section_id', sectionId);
      const version = resultsVersion, req = { next, ctrl: new AbortController() };
      req.promise = fetch(f, { signal: req.ctrl.signal }).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); }).then(text => {
        if (req.ctrl.signal.aborted || ac.signal.aborted || version !== resultsVersion) return false;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const g = grid();
        const have = new Set($$(':scope > .pc', g).map(c => c.dataset.handle).filter(Boolean));
        $$('[data-shp-grid] > .pc', doc).forEach((c, i) => {
          if (c.dataset.handle && have.has(c.dataset.handle)) return; // already on screen
          have.add(c.dataset.handle);
          const n = document.importNode(c, true); n.style.setProperty('--i', i % 8); g.appendChild(n);
        });
        const nm = $('[data-shp-more]', doc);
        if (nm) moreBox.replaceWith(document.importNode(nm, true)); else moreBox.remove();
        return true;
      });
      const done = () => { if (pageReq === req) pageReq = null; };
      req.promise.then(done, done);
      pageReq = req;
      return req.promise;
    };

    /* ---------- Show more ---------- */
    rootEl.addEventListener('click', e => {
      const btn = e.target.closest('[data-shp-morebtn]'); if (!btn) return;
      e.preventDefault();
      const moreBox = btn.closest('[data-shp-more]'), next = moreBox && moreBox.dataset.next; if (!next) return;
      if (btn.getAttribute('aria-disabled') === 'true' && !(pageReq && pageReq.next === next)) return;
      const version = resultsVersion;
      appendNext(moreBox).then(added => { if (added) afterSwap(); })
        .catch(err => { if (err.name !== 'AbortError' && !ac.signal.aborted && version === resultsVersion) location.href = next; });
    }, opt);

    /* ---------- sort menu: click, or arrow keys + Enter; Esc and clicks outside close it ---------- */
    const sortBox = $('[data-shp-sort]', rootEl);
    if (sortBox) {
      const btn = $('[data-shp-sortbtn]', sortBox), menu = $('[role="listbox"]', sortBox), opts = $$('li', menu);
      let at = 0;
      const mark = i => { at = (i + opts.length) % opts.length; opts.forEach((o, j) => o.classList.toggle('is-active', j === at)); };
      const open = () => { menu.hidden = false; btn.setAttribute('aria-expanded', 'true'); mark(Math.max(0, opts.findIndex(o => o.getAttribute('aria-selected') === 'true'))); menu.focus(); };
      const close = focusBtn => { if (menu.hidden) return; menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); if (focusBtn) btn.focus(); };
      const pick = o => {
        close(true);
        opts.forEach(x => x.setAttribute('aria-selected', x === o));
        $('[data-shp-sortnow]', sortBox).textContent = o.textContent;
        const hidden = $('[data-shp-sortval]', rootEl); if (hidden) hidden.value = o.dataset.v;
        load(formUrl());
      };
      btn.addEventListener('click', () => menu.hidden ? open() : close(), opt);
      btn.addEventListener('keydown', e => { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); } }, opt);
      opts.forEach((o, i) => { o.addEventListener('click', () => pick(o), opt); o.addEventListener('mousemove', () => mark(i), opt); });
      menu.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') { e.preventDefault(); mark(at + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); mark(at - 1); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(opts[at]); }
        else if (e.key === 'Escape' || e.key === 'Tab') close(e.key === 'Escape');
      }, opt);
      document.addEventListener('click', e => { if (!sortBox.contains(e.target)) close(); }, opt);
    }

    /* ---------- search box: narrows the sarees on screen as you type; Enter searches the store ---------- */
    const qInput = $('[data-shp-q]', rootEl);
    let qText = '';
    let loadingRest = null; // the rest of the collection loading for the search box
    const filterByText = () => {
      const g = grid(); if (!g) return;
      let shown = 0;
      $$(':scope > .pc', g).forEach(c => {
        const hay = (($('.pc-name', c) || {}).textContent + ' ' + (($('.pc-fab', c) || {}).textContent || '')).toLowerCase();
        const on = !qText || hay.indexOf(qText) > -1;
        c.style.display = on ? '' : 'none';
        if (on) shown++;
      });
      // a typed search with no match says so (the grid would otherwise just look empty)
      let qNote = $('[data-shp-qnote]', rootEl);
      if (!qNote && qText && g.parentNode) {
        qNote = document.createElement('p'); qNote.className = 'shp-qnote'; qNote.setAttribute('data-shp-qnote', ''); qNote.setAttribute('role', 'status');
        g.parentNode.insertBefore(qNote, g.nextSibling);
      }
      if (qNote) {
        qNote.hidden = !qText || shown > 0 || !!loadingRest;
        if (!qNote.hidden) qNote.textContent = `No sarees here match “${qInput ? qInput.value.trim() : qText}”. Press Enter to search the whole store.`;
      }
      placeBanner();
    };
    // the search covers the whole collection: the pages not shown yet are loaded once, in the background
    const loadRest = () => {
      if (loadingRest) return loadingRest;
      const version = resultsVersion;
      const step = () => appendNext().then(added => (added && version === resultsVersion ? step() : undefined));
      loadingRest = step().catch(() => { }).then(() => { loadingRest = null; if (version === resultsVersion) afterSwap(); });
      return loadingRest;
    };
    if (qInput) {
      let qT = null;
      qInput.addEventListener('input', () => {
        clearTimeout(qT);
        qT = setTimeout(() => { qText = qInput.value.trim().toLowerCase(); filterByText(); if (qText) loadRest(); }, 200);
      }, opt);
    }

    /* ---------- phones: the sidebar opens as the filter drawer ---------- */
    const openBtn = $('[data-shp-open]', rootEl);
    if (openBtn) openBtn.addEventListener('click', () => {
      openBtn.setAttribute('aria-expanded', 'true');
      side.setAttribute('role', 'dialog');
      openPanelEl(side, () => { openBtn.setAttribute('aria-expanded', 'false'); side.removeAttribute('role'); side.inert = !desk.matches; });
    }, opt);
    side.addEventListener('click', e => { if (e.target.closest('[data-shp-close]')) closePanel(); }, opt);
    const desk = matchMedia('(min-width: 961px)');
    const onDesk = () => {
      if (desk.matches && openPanel && openPanel.el === side) closePanel();
      side.inert = !desk.matches && !(openPanel && openPanel.el === side);
    };
    onDesk();
    desk.addEventListener ? desk.addEventListener('change', onDesk) : desk.addListener(onDesk);
    ac.signal.addEventListener('abort', () => { if (desk.removeEventListener) desk.removeEventListener('change', onDesk); else desk.removeListener(onDesk); });

    /* ---------- the toolbar gets a soft shadow once it is stuck under the header (phones) ---------- */
    if ('IntersectionObserver' in window && bar) {
      const sentinel = document.createElement('div'); sentinel.style.height = '1px'; bar.before(sentinel);
      const io = new IntersectionObserver(([en]) => bar.classList.toggle('is-stuck', !en.isIntersecting), { rootMargin: '-120px 0px 0px 0px' });
      io.observe(sentinel);
      ac.signal.addEventListener('abort', () => io.disconnect());
    }

    afterSwap();
    lastCols = colsNow();
    renderRecent(rootEl);
  }

  /* =====================================================================
     Start + theme editor hooks
     ===================================================================== */
  const initAll = scope => $$('[data-mm-shop]', scope || document).forEach(init);
  const boot = () => { findHeaders(); setOffset(); initAll(); addEventListener('load', () => { findHeaders(); setOffset(); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', e => { findHeaders(); initAll(e.target); });
  document.addEventListener('shopify:section:unload', e => { $$('[data-mm-shop]', e.target).forEach(r => { if (r._mmDestroy) r._mmDestroy(); }); });
  document.addEventListener('shopify:block:select', e => {
    // selecting the banner block in the editor shows it even when there are too few products
    const b = e.target.closest && e.target.closest('[data-shp-banner]'); if (b) b.hidden = false;
  });
})();
